import type { CSSProperties } from 'react';
import { getTeamLogoUrl } from '@/utils/teamLogo';

type MlbTeamLogoImageProps = {
  teamCode: string;
  /** Sport code (e.g. 'MLB', 'NBA', 'NFL'). Defaults to 'MLB' for backward compatibility. */
  sport?: string | null;
  className?: string;
  style?: CSSProperties;
};

/**
 * Full-colour team mark from the contest's picks-core team folder
 * (`style_config.teamAssetFolder`, or League IP default).
 * Used beside matchup abbreviations / scores.
 */
export function MlbTeamLogoImage({ teamCode, sport, className, style }: MlbTeamLogoImageProps) {
  const src = getTeamLogoUrl(teamCode, sport);
  if (!src) return null;

  return (
    <img
      src={src}
      alt=""
      aria-hidden
      className={className}
      style={style}
      onError={e => {
        e.currentTarget.style.display = 'none';
      }}
    />
  );
}
